import type { Transcoder } from '@img-arena/consoles-api-streaming/dist/transcoders'
import { streamingRestApi } from '@/service/streamingApi'

import { createBaseTableStore } from '../table'
import { FetchApiArgs, FetchApiResponse } from '../table/table.types'

const fetchApi = async (args: FetchApiArgs): Promise<FetchApiResponse<Transcoder>> => {
  const { signal } = args

  const { data } = await streamingRestApi.endpoints.transcoders.getTranscoders(signal)

  return {
    content: data,
    totalElements: data.length
  }
}

export const useTranscodersStore = createBaseTableStore<Transcoder>({
  storeName: 'DGE Transcoders',
  fetchApi
})
